/**
 * Spanish translations (flat format to avoid nesting issues)
 */
export default {
  // Basic words
  "language": "Idioma",
  "title": "Cita de Entrega",
  "confirm": "Confirmar Cita",

  // Basic information
  "baseInfo.title": "Información básica",
  "baseInfo.name": "Nombre",
  "baseInfo.phone": "Contacto",
  "baseInfo.address": "Dirección de instalación",
  "baseInfo.expectDate": "Fecha de visita esperada",
  "baseInfo.service": "Contenido del servicio",
  "baseInfo.extra": "Requisitos adicionales",
  "baseInfo.remark": "Observación",
  "baseInfo.remarkPlaceholder": "Por favor ingrese",
  "baseInfo.fillName": "Por favor ingrese su nombre",
  "baseInfo.fillContact": "Por favor ingrese su contacto",
  "baseInfo.fillAddress": "Por favor ingrese la dirección de instalación",
  "baseInfo.selectService": "Por favor seleccione el servicio",
  "baseInfo.selectDate": "Por favor seleccione la fecha de visita esperada",

  // Appointment related
  "appointment.title": "Hora de la Cita",
  "appointment.warning": "Si la entrega falla por razones del cliente, se cobrará $40",
  "appointment.days.today": "Hoy",
  "appointment.days.tomorrow": "Mañana",
  "appointment.days.monday": "Lunes",
  "appointment.days.tuesday": "Martes",
  "appointment.days.wednesday": "Miércoles",
  "appointment.days.thursday": "Jueves",
  "appointment.days.friday": "Viernes",
  "appointment.days.saturday": "Sábado",
  "appointment.days.sunday": "Domingo",
  "appointment.timeSlot.title": "Seleccionar Horario",
  "appointment.timeSlot.slot1": "08:00-11:00",
  "appointment.timeSlot.slot2": "10:00-13:00",
  "appointment.timeSlot.slot3": "12:00-15:00",
  "appointment.timeSlot.slot4": "14:00-17:00",
  "appointment.timeSlot.slot5": "17:00-20:00",

  // Contact information
  "contact.title": "Contacto Secundario",
  "contact.mobile": "Móvil",
  "contact.email": "Correo Electrónico",
  "contact.placeholder": "Por favor ingrese",

  // Door information
  "doorInfo.title": "Información de Puerta",
  "doorInfo.hasDoor": "Tiene Puerta",
  "doorInfo.noDoor": "Sin Puerta",
  "doorInfo.passwordTitle": "Contraseña de Puerta",
  "doorInfo.passwordPlaceholder": "Ingrese código de puerta",
  "doorInfo.passwordRequired": "Código de puerta requerido",

  // Delivery method
  "delivery.title": "Ubicación de Entrega",
  "delivery.placeholder": "Por favor seleccione",
  "delivery.photoOptional": "Opcional",
  "delivery.photoPlaceholder": "Subir foto de ubicación",
  "delivery.photoUploadSuccess": "Foto subida",
  "delivery.photoDeleted": "Foto eliminada",
  "delivery.viewPhoto": "Ver Foto",
  "delivery.noPhotoAvailable": "No hay foto disponible",
  "delivery.locations.frontPorch": "Porche Delantero",
  "delivery.locations.garage": "Garaje",
  "delivery.locations.backDoor": "Puerta Trasera",
  "delivery.locations.sideEntrance": "Entrada Lateral",
  "delivery.locations.buildingLobby": "Vestíbulo del Edificio",

  // Installation
  "installation.title": "Instalación Requerida",
  "installation.yes": "Sí",
  "installation.no": "No",

  // Stairs
  "stairs.title": "Entrega en Pisos Superiores",
  "stairs.yes": "Sí",
  "stairs.no": "No",

  // Success popup
  "successPopup.title": "Cita Exitosa",
  "successPopup.appointmentTime": "Hora de Entrega",
  "successPopup.cancellationNote": "Si la entrega falla por razones del cliente, se cobrará $40",
  "successPopup.viewDetails": "Ver Detalles de la Cita",

  // Error messages
  "errors.noTrackingNumber": "No se encontró un número de seguimiento válido",
  "errors.apiError": "Error al obtener información de la cita",
  "errors.networkError": "Error de conexión de red, intente más tarde",
  "errors.selectTimeSlot": "Por favor seleccione una franja horaria",

  // Order details
  "orderDetail.title": "Detalles de la Cita",
  "orderDetail.editAppointment": "Editar Cita",
  "orderDetail.loading": "Cargando...",
  "orderDetail.customerService": "Llamar a Servicio al Cliente",

  // Reseña (Review) related
  "review.title": "Reseña del cliente",
  "review.areYouSatisfied": "¿Está satisfecho con este servicio de instalación?",
  "review.satisfied": "Satisfecho",
  "review.disatisfied": "No satisfecho",
  "review.pleaseRateService": "Por favor califique este servicio",
  "review.overallScore": "Puntuación general",
  "review.workEfficiency": "Eficiencia laboral",
  "review.communicationExperience": "Experiencia de comunicación",
  "review.yourImpression": "Su impresión del técnico",
  "review.confirmSignature": "Confirmar firma",
  "review.reSign": "Firmar de nuevo",
  "review.clickSign": "Haga clic para firmar",
  "review.file": "Archivo de firma",
  "review.comment": "Comentario",
  "review.enterComment": "Por favor ingrese su comentario",
  "review.submit": "Enviar",
  "review.noOrderNo": "Falta el número de pedido",
  "review.selectSatisfaction": "Por favor seleccione satisfacción",
  "review.selectTags": "Por favor seleccione etiquetas de impresión",
  "review.selectInteractScore": "Por favor califique la comunicación",
  "review.selectWorkScore": "Por favor califique la eficiencia laboral",
  "review.selectServiceScore": "Por favor califique la puntuación general",
  "review.signRequired": "Por favor firme primero",
  "review.thanks": "¡Gracias por su reseña!",
  "review.scoreUnit": "pt",

  // Página de inicio (index) relacionada
  "index.title": "Cita de Instalación",
  "index.flowCardTitle": "Proceso de Instalación",
  "index.prepareCardTitle": "Preparación Antes de la Instalación",
  "index.step1Title": "Enviar información de la cita",
  "index.step1Desc": "Por favor complete cuidadosamente la información de la cita, tome y cargue fotos reales del entorno de instalación según sea necesario para ayudar a los técnicos a comprender la situación con anticipación.",
  "index.step2Title": "Electricista acepta el pedido / Comunicación previa a la visita",
  "index.step2Desc": "Después de que el electricista acepte el pedido, se comunicará los detalles del servicio y confirmará la hora del servicio con usted.",
  "index.step3Title": "Trabajo en el sitio",
  "index.step3Desc": "Por favor, prepare el área de instalación antes de que llegue el técnico y avísele a tiempo si hay circunstancias especiales.",
  "index.step4Title": "Confirmación de finalización / Evaluación del servicio",
  "index.step4Desc": "Supervise el trabajo del técnico en todo momento, confirme y firme después de la finalización, y se le invita a dar una evaluación real del servicio del técnico.",
  "index.prepare1": "Asegúrese de que el área de instalación esté limpia y ordenada, y retire los obstáculos que puedan afectar la instalación.",
  "index.prepare2": "Si necesita retirar equipos antiguos, haga una copia de seguridad y transfiera los datos con anticipación.",
  "index.customerService": "Servicio al Cliente",
  "index.callHotline": "Llamar a la línea directa",
  "index.nextStep": "Siguiente paso",
  "index.noOrderNoTip": "Por favor, póngase en contacto con el servicio de atención al cliente para obtener el enlace de pedido",

  // Progreso de pasos relacionado
  "stepProgress.title": "Pasos de la solicitud",
  "stepProgress.installDesc": "Instrucciones de instalación",
  "stepProgress.basicInfo": "Información básica",
  "stepProgress.installPosition": "Posición de instalación",
  "stepProgress.circuitInfo": "Información del circuito",
  "stepProgress.finish": "Cita completada",

  // Common words
  "common.cancel": "Cancelar",
  "common.confirm": "Confirmar",
  "common.prev": "Anterior",
  "common.next": "Siguiente",

  // ExtraSelectPopup related
  "extra.title": "Requisitos adicionales",
  "extra.sub": "Selección múltiple permitida",
  "extra.confirm": "Confirmar",
  "extra.需要布线": "Se requiere cableado",
  "extra.需要拆除旧设备": "Retirar equipo antiguo",
  "extra.需要打孔": "Se requiere perforación",
  "extra.需要接油机": "Conexión de máquina de aceite",
  "extra.需要配件适配": "Adaptación de accesorios",

  // ServiceSelectPopup related
  "service.title": "Seleccionar contenido del servicio",
  "service.confirm": "Confirmar",

  // New keys for InstallationPosition
  "install.title": "Posición de instalación",
  "install.position": "Posición de instalación",
  "install.wallType": "Tipo de pared",
  "install.select": "Por favor seleccione",
  "install.photo": "Foto de la posición de instalación",
  "install.photoTip": "Por favor, tome fotos de la posición de instalación desde varios ángulos para la evaluación del técnico",
  "install.concrete": "Hormigón",
  "install.wood": "Madera",
  "install.wall": "Pared",
  "install.ground": "Suelo",
  "install.onlyJpgPng": "Solo se admite formato JPG/PNG",
  "install.maxSize": "El tamaño de la imagen no puede superar los 5MB",
  "install.fileTypeError": "Error de tipo de archivo",
  "install.uploadFail": "Error al subir",
  "install.selectWallType": "Por favor seleccione el tipo de pared",
  "install.selectPosition": "Por favor seleccione la posición de instalación",
  "install.uploadPhoto": "Por favor suba la foto de la posición de instalación",

  // New keys for CircuitInfo
  "circuit.title": "Información del circuito",
  "circuit.mainBox": "Caja principal",
  "circuit.mainBoxTip": "Fotografíe el interruptor más interno para evaluar el suministro eléctrico.",
  "circuit.meter": "Medidor eléctrico",
  "circuit.wire": "Reserva de cables y entorno",
  "circuit.distance": "Distancia de la caja de distribución al smart panel",
  "circuit.distanceTip": "Grabe o suba un video para ayudar a los técnicos a evaluar la dificultad de instalación y los materiales necesarios.",
  "circuit.submit": "Enviar información",
  "circuit.onlyJpgPng": "Solo se admite formato JPG/PNG",
  "circuit.maxSize": "El tamaño de la imagen no puede superar los 15MB",
  "circuit.onlyVideo": "Solo se admiten archivos de video",
  "circuit.maxVideoSize": "El tamaño del video no puede superar los 150MB",
  "circuit.fileTypeError": "Error de tipo de archivo",
  "circuit.uploadFail": "Error al subir",
  "circuit.uploadMainBox": "Por favor suba la foto de la caja principal",
  "circuit.uploadMeter": "Por favor suba la foto del medidor eléctrico",
  "circuit.uploadWire": "Por favor suba la foto de la reserva de cables y entorno",
  "circuit.uploadDistance": "Por favor suba el video de la distancia",
  "circuit.submitSuccess": "Enviado con éxito",
  "circuit.networkError": "Error de red, envío fallido",

  // New keys for OrderSuccess
  "orderSuccess.title": "Cita completada",
  "orderSuccess.success": "Cita exitosa",
  "orderSuccess.orderId": "N.º de pedido:",
  "orderSuccess.address": "Dirección de instalación",
  "orderSuccess.name": "Nombre",
  "orderSuccess.phone": "Teléfono",
  "orderSuccess.expectTime": "Hora esperada de visita",
  "orderSuccess.customerService": "Servicio al Cliente",
  "orderSuccess.callHotline": "Llamar a la línea directa",

  // New keys for DatePickerPopup
  "datePicker.title": "Hora esperada de visita",
  "datePicker.dateTitle": "Fecha esperada",
  "datePicker.dateTip": "Se pueden seleccionar varias fechas para la programación del técnico",
  "datePicker.selected": "Seleccionado:",
  "datePicker.to": "a",
  "datePicker.period": "período",
  "datePicker.timeLabel": "Seleccionar franja horaria",
  "datePicker.time1": "08:00-12:00",
  "datePicker.time2": "13:00-17:00",
  "datePicker.time3": "18:00-21:00",
  "datePicker.month": "-",
  "datePicker.day": ""
}; 